import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:'',
    warnings: false
  },
  items:[],
  activeCart:{}
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_CART (state, isLoading){
    state.status.loading = isLoading
  },
  SET_CART (state, data){
    state.activeCart = data
  },
  SET_CART_ITEMS (state, data){
    state.items = data
  },
  ADD_CART_ITEM(state,item){
    state.items.push(item)
  },
  UPDATE_CART_ITEM(state,item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){
      items[index] = item
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')
  },
  REMOVE_CART_ITEM (state, item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){

      items.splice(index, 1)
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')
  },

  SET_TEMP_DELIVERY_DATA (state, [newDate,addressId]){
    state.activeCart.delivery_date = newDate
    state.activeCart.address_id = addressId
  },

    SET_CART_WARNINGS(state, warnings) {
      state.status.warnings = warnings
    },
}

//async methods  store.dispatch('increment')
const actions = {

  loadActiveCart ({state, commit}) {

    commit('LOADING_CART', true);

    return api.get('cart/active')
      .then(function (response) {
        commit('SET_CART', response.data.data)
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },

  updateActiveCart ({state, commit},cart) {
    if (cart.delivery_date == "") {
      //commit('SET_TEMP_DELIVERY_DATA', ['', cart.address_id]);
      return;
    }
	
    //if (state.activeCart.address_id == cart.address_id
    //  && state.activeCart.delivery_type_id == cart.delivery_type_id
    //  && state.activeCart.parcel_machine_location == cart.parcel_machine_location
    //  && state.activeCart.delivery_date == cart.delivery_date
    //  && state.activeCart.notes == cart.notes
    //  && state.activeCart.payment_type == cart.payment_type
    //  && state.activeCart.top_up == cart.top_up
    //  && state.activeCart.use_bonus == cart.use_bonus) return;

    commit('LOADING_CART', true);

    return api.post('cart/'+cart.id, cart)
      .then(function (response) {
        commit('SET_CART', response.data.data)
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },

  loadCartItems ({state, commit},cartId) {

    commit('LOADING_CART', true);

    return api.get('cart/'+cartId+'/item')
      .then(function (response) {
        commit('SET_CART_ITEMS', response.data.data)
        commit('LOADING_CART', false);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
      });
  },

  //add or update
  addCartItem ({state, commit},[cartId, item]) {

    //commit('LOADING_CART', true);

    return api.post('cart/'+cartId+'/cartitem', item)
      .then(function (response) {
        if(item.id && item.order == 0 && item.return == 0){
          commit('REMOVE_CART_ITEM', response.data.data)
        }
        else if(item.id){
          commit('UPDATE_CART_ITEM', response.data.data)
        } else {
          commit('ADD_CART_ITEM', response.data.data)
          // return Promise.resolve(response);
        }
        return Promise.resolve(response);
      })
      .catch(function (error) {
      //  commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },

  removeCartItem ({state, commit},item) {

    commit('LOADING_CART', true);

    return api.delete('cart/' + item.cart_id + '/item/'+ item.good_id)
      .then(function (response) {
        commit('REMOVE_CART_ITEM', item)
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },
  
  activatePromoCode({state, commit},code) {

    commit('LOADING_CART', true);

    return api.get('promo/activate/' + code)
      .then(function (response) {
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },

  processCart ({state, commit},cart) {

    commit('LOADING_CART', true);
    commit('SET_CART_WARNINGS', false); //reset cart items

    return api.post('cart/' + cart.id + '/processcart', cart)
      .then(function (response) {
        commit('LOADING_CART', false);
        commit('SET_CART', []); //reset cart
        commit('SET_CART_ITEMS', []); //reset cart items
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },

  createCart ({state, commit},cart) {

    commit('LOADING_CART', true);
    commit('SET_CART_WARNINGS', false); //reset cart items

    return api.post('cart')
      .then(function (response) {
        commit('SET_CART', response.data.data)
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },


  repeatLastCart({state, commit}) {

    commit('LOADING_CART', true);
    commit('SET_CART_WARNINGS', false); //reset cart items
    return api.post('cart/repeat')
      .then(function (response) {
        commit('SET_CART', response.data.data)
        commit('LOADING_CART', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  },


  addCartToNearestOrder({state, commit},cart) {

    commit('SET_CART_WARNINGS', false); //reset cart items
    commit('LOADING_CART', true);

    return api.post('cart/'+cart.id+'/addtoorder')
      .then(function (response) {
        commit('SET_CART', []); //reset cart
        commit('SET_CART_ITEMS', []); //reset cart items
        commit('SET_CART_WARNINGS', response.data.warnings); //reset cart items
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_CART', false);
        return Promise.reject(error);
      });
  }

}

export default {
  state, mutations, actions, getters
}


// WEBPACK FOOTER //
// ./src/store/modules/CartStore.js